// src/Words.js

import React, { useState, useEffect } from 'react';
import './Words.css';

const wordsData = {
    "Apple": {
      telugu: "ఆపిల్",
      hindi: "सेब",
      tamil: "ஆப்பிள்",
      kannada: "ಆಪಲ್"
    },
    "Banana": {
      telugu: "అరటిపండు",
      hindi: "केला",
      tamil: "வாழைப்பழம்",
      kannada: "ಬಾಳೆಹಣ್ಣು"
    },
    "Cat": {
      telugu: "పిల్లి",
      hindi: "बिल्ली",
      tamil: "பூனை",
      kannada: "ಬೆಕ್ಕು"
    },
    "Dog": {
      telugu: "కుక్క",
      hindi: "कुत्ता",
      tamil: "நாய்",
      kannada: "ನಾಯಿ"
    },
    "Elephant": {
      telugu: "ఏనుగు",
      hindi: "हाथी",
      tamil: "யானை",
      kannada: "ಆನೆ"
    },
    "Fish": {
      telugu: "చేప",
      hindi: "मछली",
      tamil: "மீன்",
      kannada: "ಮೀನು"
    },
    "Grapes": {
      telugu: "ద్రాక్షపండు",
      hindi: "अंगूर",
      tamil: "திராட்சை",
      kannada: "ದ್ರಾಕ್ಷಿ"
    },
    "House": {
      telugu: "ఇల్లు",
      hindi: "घर",
      tamil: "வீடு",
      kannada: "ಮನೆ"
    },
    "Ice Cream": {
      telugu: "ఐస్ క్రీమ్",
      hindi: "आइसक्रीम",
      tamil: "ஐஸ்க்ரீம்",
      kannada: "ಐಸ್‌ಕ್ರೀಮ್"
    },
    "Juice": {
      telugu: "జ్యూస్",
      hindi: "रस",
      tamil: "சாறு",
      kannada: "ಜ್ಯೂಸ್"
    },
    "Kite": {
      telugu: "గాలిపటం",
      hindi: "पतंग",
      tamil: "பட்டம்",
      kannada: "ಗಾಳಿ ಹಕ್ಕಿ"
    },
    "Lion": {
      telugu: "సింహం",
      hindi: "सिंह",
      tamil: "சிங்கம்",
      kannada: "ಸಿಂಹ"
    },
    "Monkey": {
      telugu: "కోతిడి",
      hindi: "बंदर",
      tamil: "குரங்கு",
      kannada: "ಕೋತಿ"
    },
    "Nest": {
      telugu: "గూడు",
      hindi: "घोंसला",
      tamil: "கூடு",
      kannada: "ಗೂಡು"
    },
    "Orange": {
      telugu: "నారింజ",
      hindi: "संतरा",
      tamil: "ஆரஞ்சு",
      kannada: "ಕಿತ್ತಳೆ ಹಣ್ಣು"
    },
    "Parrot": {
      telugu: "చిలుక",
      hindi: "तोता",
      tamil: "கிளி",
      kannada: "ಗಿಣಿ"
    },
    "Queen": {
      telugu: "రాణి",
      hindi: "रानी",
      tamil: "ராணி",
      kannada: "ರಾಣಿ"
    },
    "Rabbit": {
      telugu: "కుందేలు",
      hindi: "खरगोश",
      tamil: "முயல்",
      kannada: "ಮೊಲ"
    },
    "Sun": {
      telugu: "సూర్యుడు",
      hindi: "सूरज",
      tamil: "சூரியன்",
      kannada: "ಸೂರ್ಯ"
    },
    "Tiger": {
      telugu: "పులి",
      hindi: "बाघ",
      tamil: "புலி",
      kannada: "ಹುಲಿ"
    },
    "Umbrella": {
      telugu: "కొడుగు",
      hindi: "छाता",
      tamil: "குடை",
      kannada: "ಚಾತ್ರಿ"
    },
    "Violin": {
      telugu: "వయలిన్",
      hindi: "वायोलिन",
      tamil: "வயலின்",
      kannada: "ವಯಲಿನ್"
    },
    "Water": {
      telugu: "నీరు",
      hindi: "पानी",
      tamil: "நீர்",
      kannada: "ನೀರು"
    },
    "Xylophone": {
      telugu: "జైలోఫోన్",
      hindi: "ज़ाइलोफ़ोन",
      tamil: "சைலோபோன்",
      kannada: "ಜೈಲೋಫೋನ್"
    },
    "Yogurt": {
      telugu: "పెరుగు",
      hindi: "दही",
      tamil: "தயிர்",
      kannada: "ಮೊಸರು"
    },
    "Zebra": {
      telugu: "జెబ్రా",
      hindi: "ज़ेबरा",
      tamil: "ஜிப்ரா",
      kannada: "ಜೇಬ್ರಾ"
    },
    
        "When": {
          telugu: "ఎప్పుడు",
          hindi: "कब",
          tamil: "எப்போது",
          kannada: "ಯಾವಾಗ"
        },
        "What": {
          telugu: "ఏమి",
          hindi: "क्या",
          tamil: "என்ன",
          kannada: "ಏನು"
        },
        "Why": {
          telugu: "ఎందుకు",
          hindi: "क्यों",
          tamil: "ஏன்",
          kannada: "ಯಾಕೆ"
        },
        "How": {
          telugu: "ఎలా",
          hindi: "कैसे",
          tamil: "எப்படி",
          kannada: "ಹೇಗೆ"
        },
        "Whose": {
          telugu: "దేనిది",
          hindi: "किसका",
          tamil: "யாருடைய",
          kannada: "ಯಾರ"
        },
        "Where": {
          telugu: "ఎక్కడ",
          hindi: "कहाँ",
          tamil: "எங்கே",
          kannada: "ಎಲ್ಲಿ"
        },
        "Which": {
          telugu: "ఏది",
          hindi: "कौनसा",
          tamil: "எது",
          kannada: "ಯಾವುದು"
        },
        "Who": {
          telugu: "ఎవర",
          hindi: "कौन",
          tamil: "யார்",
          kannada: "ಯಾರು"
        },
        "Can": {
          telugu: "చూడగలమా",
          hindi: "सकते",
          tamil: "முடியும்",
          kannada: "ಮಾಡಬಹುದೇ"
        },
        "Will": {
          telugu: "ఉంటుంది",
          hindi: "होगा",
          tamil: "விருப்பம்",
          kannada: "ಇರುವುದಿಲ್ಲ"
        },
        "Is": {
          telugu: "ఉన్నది",
          hindi: "है",
          tamil: "அது",
          kannada: "ಇದು"
        },
        "Are": {
          telugu: "ఉన్నారుగా",
          hindi: "हैं",
          tamil: "அவர்கள்",
          kannada: "ಅವರು"
        },
        "Do": {
          telugu: "చేసే",
          hindi: "करना",
          tamil: "செய்கின்றன",
          kannada: "ಮಾಡುತ್ತದೆ"
        },
        "Does": {
          telugu: "చేస్తుంది",
          hindi: "करता है",
          tamil: "செய்யும்",
          kannada: "ಮಾಡುತ್ತದೆ"
        },
        "Did": {
          telugu: "చేశారా",
          hindi: "किया था",
          tamil: "செய்துவிட்டேன்",
          kannada: "ಮಾಡಿದರು"
        },
        "Have": {
          telugu: "ఉన్నది",
          hindi: "है",
          tamil: "வேண்டும்",
          kannada: "ಇದೆ"
        },
        "Has": {
          telugu: "ఉన్నది",
          hindi: "है",
          tamil: "வேண்டும்",
          kannada: "ಇದೆ"
        },
        "Had": {
          telugu: "ఉందిరా",
          hindi: "था",
          tamil: "இருந்தது",
          kannada: "ಇತ್ತು"
        },
        "Shall": {
          telugu: "ఉంటున్నది",
          hindi: "सकता है",
          tamil: "விருப்பம்",
          kannada: "ಮಾಡುತ್ತಾ"
        },
        "Should": {
          telugu: "కావాలి",
          hindi: "चाहिए",
          tamil: "வேண்டும்",
          kannada: "ಬೇಡ"
        },
      
        
            "School": {
              telugu: "పాఠశాల",
              hindi: "स्कूल",
              tamil: "பள்ளி",
              kannada: "ಶಾಲೆ"
            },
            "Teacher": {
              telugu: "ఉపాధ్యాయుడు",
              hindi: "शिक्षक",
              tamil: "ஆசிரியர்",
              kannada: "ಗುರು"
            },
            "Student": {
              telugu: "విద్యార్థి",
              hindi: "विद्यार्थी",
              tamil: "மாணவன்",
              kannada: "ವಿದ್ಯಾರ್ಥಿ"
            },
            "Book": {
              telugu: "పుస్తకం",
              hindi: "किताब",
              tamil: "புத்தகம்",
              kannada: "ಪುಸ್ತಕ"
            },
            "Notebook": {
              telugu: "నోట్బుక్",
              hindi: "नोटबुक",
              tamil: "நோட்புக்",
              kannada: "ನೋಟ್ಬುಕ್"
            },
            "Pen": {
              telugu: "పెన్",
              hindi: "पेन",
              tamil: "பேனா",
              kannada: "ಪೆನ್"
            },
            "Pencil": {
              telugu: "పెన్సిల్",
              hindi: "पेंसिल",
              tamil: "எழுதுகோல்",
              kannada: "ಪೆನ್ಸಿಲ್"
            },
            "Eraser": {
              telugu: "రబ్బరు",
              hindi: "रबर",
              tamil: "அழிப்பு",
              kannada: "ಅಳಿಸಿಹಾಕುವ"
            },
            "Desk": {
              telugu: "డెస్క్",
              hindi: "डेस्क",
              tamil: "மேஜை",
              kannada: "ಮೇಜ"
            },
            "Chair": {
              telugu: "కుర్చీ",
              hindi: "कुर्सी",
              tamil: "நாற்காலி",
              kannada: "ಕುರ್ಚಿ"
            },
            "Playground": {
              telugu: "ఆట స్థలం",
              hindi: "खेल का मैदान",
              tamil: "விளையாட்டு மைதானம்",
              kannada: "ಆಟದ ಮೈದಾನ"
            },
            "Slide": {
              telugu: "స్లయిడ్",
              hindi: "स्लाइड",
              tamil: "ஸ்லைடு",
              kannada: "ಜಾರಿ"
            },
            "Swing": {
              telugu: "ఊయల",
              hindi: "झूला",
              tamil: "ஊஞ்சல்",
              kannada: "ಬೀಸು"
            },
            "Jungle Gym": {
              telugu: "జంగిల్ జిమ్",
              hindi: "जंगल जिम",
              tamil: "ஜங்கிள் ஜிம்",
              kannada: "ಜಂಗಲ್ ಜಿಮ್"
            },
            "Ball": {
              telugu: "బంతి",
              hindi: "गेंद",
              tamil: "பந்து",
              kannada: "ಚೆಂಡು"
            },
            "Jump Rope": {
              telugu: "దారంతో చెయ్యి",
              hindi: "रस्सी कूदना",
              tamil: "கயிறு பாய்ச்சுதல்",
              kannada: "ರಸ್ಸಿ ನಿಲ್ಲಿಸುವುದು"
            },
            "Teacher's Desk": {
              telugu: "ఉపాధ్యాయుడి డెస్క్",
              hindi: "शिक्षक का डेस्क",
              tamil: "ஆசிரியரின் மேஜை",
              kannada: "ಗುರುನ ಮೋಡಿಗೆ"
            },
            "Library": {
              telugu: "గ్రంథాలయం",
              hindi: "पुस्तकालय",
              tamil: "நூலகம்",
              kannada: "ಗ್ರಂಥಾಲಯ"
            },
            "Homework": {
              telugu: "గృహపాఠం",
              hindi: "गृहकार्य",
              tamil: "வீட்டுப்பாடம்",
              kannada: "ಗೃಹಕಾರ್ಯ"
            },
            "Classroom": {
              telugu: "తరగతి గది",
              hindi: "कक्षा",
              tamil: "வகுப்பு",
              kannada: "ತರಗತಿ ಕೊಠಡಿ"
            },
          

                "Permission": {
                  telugu: "అనుమతి",
                  hindi: "अनुमति",
                  tamil: "அனுமதி",
                  kannada: "ಅನುಮತಿ"
                },
                "Washroom": {
                  telugu: "మరుగు",
                  hindi: "शौचालय",
                  tamil: "கழிவறை",
                  kannada: "ಶೌಚಾಲಯ"
                },
                "Leave": {
                  telugu: "సెలవు",
                  hindi: "छुट्टी",
                  tamil: "விடுமுறை",
                  kannada: "ರಜೆ"
                },
                "Absent": {
                  telugu: "లేకపోవడం",
                  hindi: "अनुपस्थित",
                  tamil: "இல்லை",
                  kannada: "ಹಾಜರಿಲ್ಲ"
                },
                "Late": {
                  telugu: "ఆలస్యం",
                  hindi: "देर",
                  tamil: "தாமதம்",
                  kannada: "ತಡ"
                },
                "Excuse": {
                  telugu: "నిరాకరించడం",
                  hindi: "माफी",
                  tamil: "மன்னிப்பு",
                  kannada: "ಕ್ಷಮೆ"
                },
                "Rest": {
                  telugu: "విరామం",
                  hindi: "आराम",
                  tamil: "ஓய்வு",
                  kannada: "ಉಳಿದಿದೆ"
                },
                "Nurse": {
                  telugu: "నర్సు",
                  hindi: "नर्स",
                  tamil: "செவிலியர்",
                  kannada: "ನರ್ಸ್"
                },
                "Office": {
                  telugu: "కార్యాలయం",
                  hindi: "कार्यालय",
                  tamil: "அலுவலகம்",
                  kannada: "ಕಚೇರಿ"
                },
                "Sick": {
                  telugu: "అస్వస్థత",
                  hindi: "बीमार",
                  tamil: "நோயின்றி",
                  kannada: "ಅಸ್ವಸ್ಥ"
                },
                "Doctor": {
                  telugu: "డాక్టర్",
                  hindi: "डॉक्टर",
                  tamil: "மருத்துவர்",
                  kannada: "ಡಾಕ್ಟರ್"
                },
                "Medicine": {
                  telugu: "మెడిసిన్",
                  hindi: "दवा",
                  tamil: "மருந்து",
                  kannada: "ಮೆಡಿಸಿನ್"
                },
                "Clinic": {
                  telugu: "క్లినిక్",
                  hindi: "क्लिनिक",
                  tamil: "வைத்தியசாலை",
                  kannada: "ಕ್ಲಿನಿಕ್"
                },
                "Break": {
                  telugu: "విరామం",
                  hindi: "विराम",
                  tamil: "இடைவேளை",
                  kannada: "ವಿರಾಮ"
                },
                "Water": {
                  telugu: "నీరు",
                  hindi: "पानी",
                  tamil: "நீர்",
                  kannada: "ನೀರು"
                },
                "Lunch": {
                  telugu: "మధ్యాహ్న భోజనం",
                  hindi: "दोपहर का खाना",
                  tamil: "மதிய உணவு",
                  kannada: "ಮಧ್ಯಾನ್ಹ ಭೋಜನ"
                },
                "Recess": {
                  telugu: "విరామం",
                  hindi: "अवकाश",
                  tamil: "இடைவேளை",
                  kannada: "ವಿರಾಮ"
                },
                "Bell": {
                  telugu: "గంట",
                  hindi: "घंटी",
                  tamil: "மணியாரப்பனை",
                  kannada: "ಗಂಟೆ"
                },
                "Backpack": {
                  telugu: "బ్యాక్‌ప్యాక్",
                  hindi: "बैकपैक",
                  tamil: "பைக்பேக்",
                  kannada: "ಬ್ಯಾಕ್ ಪ್ಯಾಕ್"
                },
                "Uniform": {
                  telugu: "యూనిఫారమ్",
                  hindi: "वर्दी",
                  tamil: "அணிவகுப்பு",
                  kannada: "ಯೂನಿಫಾರ್ಮ್"
                },


            
                    // Colors
                    "Red": {
                      telugu: "ఎరుపు",
                      hindi: "लाल",
                      tamil: "சிவப்பு",
                      kannada: "ಕೆಂಪು"
                    },
                    "Blue": {
                      telugu: "నీలం",
                      hindi: "नीला",
                      tamil: "நீலம்",
                      kannada: "ನೀಲಿ"
                    },
                    "Green": {
                      telugu: "ఆకుపచ్చ",
                      hindi: "हरा",
                      tamil: "பச்சை",
                      kannada: "ಹಸಿರು"
                    },
                    "Yellow": {
                      telugu: "పసుపు",
                      hindi: "पीला",
                      tamil: "மஞ்சள்",
                      kannada: "ಹಳದಿ"
                    },
                    "Black": {
                      telugu: "నలుపు",
                      hindi: "काला",
                      tamil: "கருப்பு",
                      kannada: "ಕಪ್ಪು"
                    },
                    
                    // Animals
                    "Lion": {
                      telugu: "సింహం",
                      hindi: "सिंह",
                      tamil: "சிங்கம்",
                      kannada: "ಸಿಂಹ"
                    },
                    "Tiger": {
                      telugu: "పులి",
                      hindi: "बाघ",
                      tamil: "புலி",
                      kannada: "ಹುಲಿ"
                    },
                    "Elephant": {
                      telugu: "ఏనుగు",
                      hindi: "हाथी",
                      tamil: "யானை",
                      kannada: "ಆನೆ"
                    },
                    "Cat": {
                      telugu: "పిల్లి",
                      hindi: "बिल्ली",
                      tamil: "பூனை",
                      kannada: "ಬೆಕ್ಕು"
                    },
                    "Dog": {
                      telugu: "కుక్క",
                      hindi: "कुत्ता",
                      tamil: "நாய்",
                      kannada: "ನಾಯಿ"
                    },
                    
                    // Birds
                    "Parrot": {
                      telugu: "చిలుక",
                      hindi: "तोता",
                      tamil: "கிளி",
                      kannada: "ಗಿಣಿ"
                    },
                    "Peacock": {
                      telugu: "నెమలి",
                      hindi: "मोर",
                      tamil: "மயில்",
                      kannada: "ನವಿಲು"
                    },
                    "Sparrow": {
                      telugu: "గువ్వ",
                      hindi: "गौरैया",
                      tamil: "சிட்டுக்குருவி",
                      kannada: "ಗೋರವಿ"
                    },
                    "Crow": {
                      telugu: "కాకి",
                      hindi: "कौआ",
                      tamil: "காகம்",
                      kannada: "ಕಾಗೆ"
                    },
                    "Pigeon": {
                      telugu: "పావురం",
                      hindi: "कबूतर",
                      tamil: "புறா",
                      kannada: "ಪಾರಿವಾಳ"
                    },
                    
                    // Vehicles
                    "Car": {
                      telugu: "కారు",
                      hindi: "कार",
                      tamil: "கார்",
                      kannada: "ಕಾರು"
                    },
                    "Bus": {
                      telugu: "బస్సు",
                      hindi: "बस",
                      tamil: "பஸ்",
                      kannada: "ಬಸ್"
                    },
                    "Bike": {
                      telugu: "బైకు",
                      hindi: "बाइक",
                      tamil: "பைக்",
                      kannada: "ಬೈಕ್"
                    },
                    "Train": {
                      telugu: "రైలు",
                      hindi: "ट्रेन",
                      tamil: "ரெயில்",
                      kannada: "ರೈಲು"
                    },
                    "Truck": {
                      telugu: "ట్రక్కు",
                      hindi: "ट्रक",
                      tamil: "டிரக்",
                      kannada: "ಟ್ರಕ್"
                    },
                    
                    // Flowers
                    "Rose": {
                      telugu: "గులాబీ",
                      hindi: "गुलाब",
                      tamil: "ரோஜா",
                      kannada: "ಗುಲಾಬಿ"
                    },
                    "Lily": {
                      telugu: "లిల్లీ",
                      hindi: "कुमुदिनी",
                      tamil: "அல்லி",
                      kannada: "ಕೊಗೆಳೆ"
                    },
                    "Jasmine": {
                      telugu: "మల్లె",
                      hindi: "चमेली",
                      tamil: "மல்லிகை",
                      kannada: "ಮಲ್ಲಿಗೆ"
                    },
                    "Sunflower": {
                      telugu: "సూర్యకాంతి",
                      hindi: "सूरजमुखी",
                      tamil: "சூரியகாந்தி",
                      kannada: "ಸೂರ್ಯಕಾಂತಿ"
                    },
                    "Marigold": {
                      telugu: "బంతి",
                      hindi: "गेंदे का फूल",
                      tamil: "சாமந்தி",
                      kannada: "ಚೆಂಡು ಹೂ"
                    },
                    
                    // Additional words
                    "Rainbow": {
                      telugu: "ఇంద్రధనస్సు",
                      hindi: "इंद्रधनुष",
                      tamil: "வானவில்",
                      kannada: "ಇಂದ್ರಚಾಪ"
                    },
                    "Zebra": {
                      telugu: "జెబ్రా",
                      hindi: "ज़ेबरा",
                      tamil: "ஜிப்ரா",
                      kannada: "ಜೇಬ್ರಾ"
                    },
                    "Sparrow": {
                      telugu: "గువ్వ",
                      hindi: "गौरैया",
                      tamil: "சிட்டுக்குருவி",
                      kannada: "ಗೋರವಿ"
                    },
                    "Helicopter": {
                      telugu: "హెలికాప్టర్",
                      hindi: "हेलिकॉप्टर",
                      tamil: "விமானம்",
                      kannada: "ಹೆಲಿಕಾಪ್ಟರ್"
                    },
                    "Bouquet": {
                      telugu: "పుష్పగుచ్చం",
                      hindi: "गुलदस्ता",
                      tamil: "மலர் தூவு",
                      kannada: "ಮಾಲಾ"
                    },
                    "Orchid": {
                      telugu: "ఆర్కిడ్",
                      hindi: "ऑर्किड",
                      tamil: "ஆர்க்கிட்",
                      kannada: "ಆರ್ಕಿಡ್"
                    },
                    "Tulip": {
                      telugu: "ట్యూలిప్",
                      hindi: "ट्यूलिप",
                      tamil: "தூளிப்",
                      kannada: "ಟ್ಯೂಲಿಪ್"
                    },
                    "Frog": {
                      telugu: "దడ్డువ",
                      hindi: "मेंढक",
                      tamil: "தவளை",
                      kannada: "ಕಪ್ಪೆ"
                    },
                    "Elephant": {
                      telugu: "ఏనుగు",
                      hindi: "हाथी",
                      tamil: "யானை",
                      kannada: "ಆನೆ"
                    },
                  
              
                    
                        // Weeks
                        "Sunday": {
                          telugu: "ఆదివారం",
                          hindi: "रविवार",
                          tamil: "ஞாயிற்றுக்கிழமை",
                          kannada: "ಭಾನುವಾರ"
                        },
                        "Monday": {
                          telugu: "సోమవారం",
                          hindi: "सोमवार",
                          tamil: "திங்கள்",
                          kannada: "ಸೋಮವಾರ"
                        },
                        "Tuesday": {
                          telugu: "మంగళవారం",
                          hindi: "मंगलवार",
                          tamil: "செவ்வாய்",
                          kannada: "ಮಂಗಳವಾರ"
                        },
                        "Wednesday": {
                          telugu: "బుధవారం",
                          hindi: "बुधवार",
                          tamil: "புதன்",
                          kannada: "ಬುಧವಾರ"
                        },
                        "Thursday": {
                          telugu: "గురువారం",
                          hindi: "गुरूवार",
                          tamil: "வியாழன்",
                          kannada: "ಗುರುವಾರ"
                        },
                        "Friday": {
                          telugu: "శుక్రవారం",
                          hindi: "शुक्रवार",
                          tamil: "வெள்ளி",
                          kannada: "ಶುಕ್ರವಾರ"
                        },
                        "Saturday": {
                          telugu: "శనివారం",
                          hindi: "शनिवार",
                          tamil: "சனி",
                          kannada: "ಶನಿವಾರ"
                        },
                      
                        // Months
                        "January": {
                          telugu: "జనవరి",
                          hindi: "जनवरी",
                          tamil: "ஜனவரி",
                          kannada: "ಜನವರಿ"
                        },
                        "February": {
                          telugu: "ఫిబ్రవరి",
                          hindi: "फरवरी",
                          tamil: "பிப்ரவரி",
                          kannada: "ಫೆಬ್ರವರಿ"
                        },
                        "March": {
                          telugu: "మార్చి",
                          hindi: "मार्च",
                          tamil: "மார்ச்",
                          kannada: "ಮಾರ್ಚ್"
                        },
                        "April": {
                          telugu: "ఏప్రిల్",
                          hindi: "अप्रैल",
                          tamil: "ஏப்ரல்",
                          kannada: "ಏಪ್ರಿಲ್"
                        },
                        "May": {
                          telugu: "మే",
                          hindi: "मई",
                          tamil: "மே",
                          kannada: "ಮೇ"
                        },
                        "June": {
                          telugu: "జూన్",
                          hindi: "जून",
                          tamil: "ஜூன்",
                          kannada: "ಜೂನ್"
                        },
                        "July": {
                          telugu: "జూలై",
                          hindi: "जुलाई",
                          tamil: "ஜூலை",
                          kannada: "ಜುಲೈ"
                        },
                        "August": {
                          telugu: "ఆగస్టు",
                          hindi: "अगस्त",
                          tamil: "ஆகஸ்ட்",
                          kannada: "ಆಗಸ್ಟ್"
                        },
                        "September": {
                          telugu: "సెప్టెంబర్",
                          hindi: "सितंबर",
                          tamil: "செப்டம்பர்",
                          kannada: "ಸೆಪ್ಟೆಂಬರ್"
                        },
                        "October": {
                          telugu: "అక్టోబర్",
                          hindi: "अक्टूबर",
                          tamil: "அக்டோபர்",
                          kannada: "ಅಕ್ಟೋಬರ್"
                        },
                        "November": {
                          telugu: "నవంబర్",
                          hindi: "नवंबर",
                          tamil: "நவம்பர்",
                          kannada: "ನವೆಂಬರ್"
                        },
                        "December": {
                          telugu: "డిసెంబర్",
                          hindi: "दिसंबर",
                          tamil: "டிசம்பர்",
                          kannada: "ಡಿಸೆಂಬರ್"
                        },
                      
                        // Seasons
                        "Spring": {
                          telugu: "వసంతం",
                          hindi: "बसंत",
                          tamil: "வசந்தம்",
                          kannada: "ವಸಂತ"
                        },
                        "Summer": {
                          telugu: "గ్రీష్మ",
                          hindi: "गर्मी",
                          tamil: "கோடை",
                          kannada: "ಬೇಸಿಗೆ"
                        },
                        "Autumn": {
                          telugu: "శరదృతువు",
                          hindi: "पतझड़",
                          tamil: "இலையுதிர்",
                          kannada: "ಶರತ್ಕಾಲ"
                        },
                        "Winter": {
                          telugu: "శీతాకాలం",
                          hindi: "सर्दी",
                          tamil: "குளிர்காலம்",
                          kannada: "ಚಳಿಕಾಲ"
                        },
                        
                        // Climate
                        "Rainy": {
                          telugu: "వర్షం",
                          hindi: "बारिश",
                          tamil: "மழை",
                          kannada: "ಮಳೆ"
                        },
                        "Sunny": {
                          telugu: "ఎండ",
                          hindi: "धूप",
                          tamil: "சூரியன்",
                          kannada: "ಸುರ್ಯ ಪ್ರಕಾಶ"
                        },
                        "Windy": {
                          telugu: "గాలి",
                          hindi: "हवादार",
                          tamil: "காற்று",
                          kannada: "ಗಾಳಿಯ"
                        },
                        "Cloudy": {
                          telugu: "మేఘావృతం",
                          hindi: "बादल",
                          tamil: "மேகமூட்டம்",
                          kannada: "ಮೊಡಸನ್ನಿವೇಶ"
                        },
                        "Stormy": {
                          telugu: "తుఫాను",
                          hindi: "तूफान",
                          tamil: "புயல்",
                          kannada: "ಬೇಶ್"
                        },
                      
                        // Plants
                        "Tree": {
                          telugu: "చెట్టు",
                          hindi: "पेड़",
                          tamil: "மரம்",
                          kannada: "ಮರ"
                        },
                        "Flower": {
                          telugu: "పువ్వు",
                          hindi: "फूल",
                          tamil: "மலர்",
                          kannada: "ಹೂ"
                        },
                        "Leaf": {
                          telugu: "ఆకు",
                          hindi: "पत्ता",
                          tamil: "இலை",
                          kannada: "ಇಲೆ"
                        },
                        "Root": {
                          telugu: "రెమ్మ",
                          hindi: "जड़",
                          tamil: "வேர்",
                          kannada: "ಬೇರು"
                        },
                        "Stem": {
                          telugu: "కొమ్మ",
                          hindi: "डंठल",
                          tamil: "தண்டு",
                          kannada: "ದಂಡೆ"
                        },
                      
                        
                            // Numbers
                            "One": {
                              telugu: "ఒకటి",
                              hindi: "एक",
                              tamil: "ஒன்று",
                              kannada: "ಒಂದು"
                            },
                            "Two": {
                              telugu: "రెండు",
                              hindi: "दो",
                              tamil: "இரண்டு",
                              kannada: "ಎರಡು"
                            },
                            "Three": {
                              telugu: "మూడు",
                              hindi: "तीन",
                              tamil: "மூன்று",
                              kannada: "ಮೂರು"
                            },
                            "Four": {
                              telugu: "నాలుగు",
                              hindi: "चार",
                              tamil: "நான்கு",
                              kannada: "ನಾಲ್ಕು"
                            },
                            "Five": {
                              telugu: "యిదు",
                              hindi: "पाँच",
                              tamil: "ஐந்து",
                              kannada: "ಐದು"
                            },
                          
                            // Fish
                            "Goldfish": {
                              telugu: "గోల్డ్‌ఫిష్",
                              hindi: "गोल्डफ़िश",
                              tamil: "சரத்து மீன்",
                              kannada: "ಗೋಲ್ಡ್ಫಿಷ್"
                            },
                            "Shark": {
                              telugu: "శార్క్",
                              hindi: "शार्क",
                              tamil: "சுறா",
                              kannada: "ಶಾರ್ಕ್"
                            },
                            "Catfish": {
                              telugu: "చేప",
                              hindi: "कैटफ़िश",
                              tamil: "சரத்து மீன்",
                              kannada: "ಕೆಟ್ಟು"
                            },
                            "Salmon": {
                              telugu: "సాల్మన్",
                              hindi: "सैल्मन",
                              tamil: "சால்மன் மீன்",
                              kannada: "ಸಾಲ್ಮನ್"
                            },
                            "Tuna": {
                              telugu: "ట్యూనా",
                              hindi: "टूना",
                              tamil: "துணா மீன்",
                              kannada: "ಟ್ಯೂನ"
                            },
                          
                            // Games
                            "Soccer": {
                              telugu: "సాకర్",
                              hindi: "सॉकर",
                              tamil: "கால்பந்து",
                              kannada: "ಸಾಕರ್"
                            },
                            "Cricket": {
                              telugu: "క్రికెట్",
                              hindi: "क्रिकेट",
                              tamil: "கிரிக்கெட்",
                              kannada: "ಕ್ರಿಕೆಟ್"
                            },
                            "Basketball": {
                              telugu: "బాస్కెట్‌బాల్",
                              hindi: "बास्केटबॉल",
                              tamil: "கூடிக்கிண்ணம்",
                              kannada: "ಬಾಸ್ಕೆಟ್ಬಾಲ್"
                            },
                            "Tennis": {
                              telugu: "టెన్నిస్",
                              hindi: "टेनिस",
                              tamil: "டென்னிஸ்",
                              kannada: "ಟೆನಿಸ್"
                            },
                            "Hockey": {
                              telugu: "హాకీ",
                              hindi: "हॉकी",
                              tamil: "ஹாக்கி",
                              kannada: "ಹಾಕಿ"
                            },
                          
                            // Currency
                            "Dollar": {
                              telugu: "డాలర్",
                              hindi: "डॉलर",
                              tamil: "டாலர்",
                              kannada: "ಡಾಲರ್"
                            },
                            "Rupee": {
                              telugu: "రూపాయి",
                              hindi: "रुपया",
                              tamil: "ரூபாய்",
                              kannada: "ರೂಪಾಯಿ"
                            },
                            "Euro": {
                              telugu: "యూరో",
                              hindi: "यूरो",
                              tamil: "யூரோ",
                              kannada: "ಯುರೋ"
                            },
                            "Pound": {
                              telugu: "పౌండ్",
                              hindi: "पाउंड",
                              tamil: "பவுண்டு",
                              kannada: "ಪೌಂಡ್"
                            },
                            "Yen": {
                              telugu: "యెన్",
                              hindi: "येन",
                              tamil: "யென்",
                              kannada: "ಯೆನ್"
                            },
                          
                            // Time
                            "Hour": {
                              telugu: "గంట",
                              hindi: "घंटा",
                              tamil: "மணி",
                              kannada: "ಗಂಟೆ"
                            },
                            "Minute": {
                              telugu: "నిమిషం",
                              hindi: "मिनट",
                              tamil: "நிமிடம்",
                              kannada: "ನಿಮಿಷ"
                            },
                            "Second": {
                              telugu: "సెకండ్",
                              hindi: "सेकंड",
                              tamil: "விநாடி",
                              kannada: "ಸೆಕೆಂಡ"
                            },
                            "Day": {
                              telugu: "రోజు",
                              hindi: "दिन",
                              tamil: "நாள்",
                              kannada: "ದಿನ"
                            },
                            "Night": {
                              telugu: "రాత్రి",
                              hindi: "रात",
                              tamil: "இரவு",
                              kannada: "ರಾತ್ರಿ"
                            },
                          
                            // Additional words
                            "Week": {
                              telugu: "వారం",
                              hindi: "सप्ताह",
                              tamil: "வாரம்",
                              kannada: "ವಾರ"
                            },
                            "Month": {
                              telugu: "నెల",
                              hindi: "महीना",
                              tamil: "மாதம்",
                              kannada: "ತಿಂಗಳು"
                            },
                            "Year": {
                              telugu: "సంవత్సరం",
                              hindi: "साल",
                              tamil: "ஆண்டு",
                              kannada: "ವರ್ಷ"
                            },
                            "Sunrise": {
                              telugu: "సూర్యోదయం",
                              hindi: "सूर्योदय",
                              tamil: "சூரிய உதயம்",
                              kannada: "ಸೂರ್ಯೋದಯ"
                            },
                            "Sunset": {
                              telugu: "సూర్యాస్తమయం",
                              hindi: "सूर्यास्त",
                              tamil: "சூரிய அஸ்தமனம்",
                              kannada: "ಸೂರ್ಯಾಸ್ತ"
                            },
                          
                            
                                // Symbols
                                "Plus": {
                                  telugu: "ప్లస్",
                                  hindi: "प्लस",
                                  tamil: "கூட்டல்",
                                  kannada: "ಪ್ಲಸ್"
                                },
                                "Minus": {
                                  telugu: "మైనస్",
                                  hindi: "माइनस",
                                  tamil: "கழித்தல்",
                                  kannada: "ಮೈನಸ್"
                                },
                                "Equal": {
                                  telugu: "సమాన",
                                  hindi: "बराबर",
                                  tamil: "சமன்",
                                  kannada: "ಸಮಾನ"
                                },
                                "Percentage": {
                                  telugu: "శాతం",
                                  hindi: "प्रतिशत",
                                  tamil: "சதவீதம்",
                                  kannada: "ಶೇಕಡಾ"
                                },
                                "Division": {
                                  telugu: "విభజన",
                                  hindi: "विभाजन",
                                  tamil: "பகுத்தல்",
                                  kannada: "ವಿಭಜನೆ"
                                },
                              
                                // School Subject Names
                                "Mathematics": {
                                  telugu: "గణితశాస్త్రం",
                                  hindi: "गणित",
                                  tamil: "கணிதம்",
                                  kannada: "ಗಣಿತ"
                                },
                                "Science": {
                                  telugu: "విజ్ఞానశాస్త్రం",
                                  hindi: "विज्ञान",
                                  tamil: "அறிவியல்",
                                  kannada: "ವಿಜ್ಞಾನ"
                                },
                                "History": {
                                  telugu: "చరిత్ర",
                                  hindi: "इतिहास",
                                  tamil: "வரலாறு",
                                  kannada: "ಇತಿಹಾಸ"
                                },
                                "Geography": {
                                  telugu: "భూగోళశాస్త్రం",
                                  hindi: "भूगोल",
                                  tamil: "புவியியல்",
                                  kannada: "ಭೂಗೋಳ"
                                },
                                "English": {
                                  telugu: "ఆంగ్లం",
                                  hindi: "अंग्रेज़ी",
                                  tamil: "ஆங்கிலம்",
                                  kannada: "ಇಂಗ್ಲೀಷ್"
                                },
                              
                                // Household Items
                                "Table": {
                                  telugu: "మెజ",
                                  hindi: "मेज़",
                                  tamil: "மேசை",
                                  kannada: "ಟೇಬಲ್"
                                },
                                "Chair": {
                                  telugu: "కుర్చీ",
                                  hindi: "कुर्सी",
                                  tamil: "நாற்காலி",
                                  kannada: "ಕುರ್ಚಿ"
                                },
                                "Sofa": {
                                  telugu: "సోఫా",
                                  hindi: "सोफ़ा",
                                  tamil: "சோபா",
                                  kannada: "ಸೋಫಾ"
                                },
                                "Bed": {
                                  telugu: "మంచం",
                                  hindi: "बिस्तर",
                                  tamil: "படுக்கை",
                                  kannada: "ಹಾಸಿಗೆ"
                                },
                                "Lamp": {
                                  telugu: "లాంప్",
                                  hindi: "लैंप",
                                  tamil: "லம்ப்",
                                  kannada: "ದೀಪ"
                                },
                              
                                // Others
                                "Computer": {
                                  telugu: "కంప్యూటర్",
                                  hindi: "कंप्यूटर",
                                  tamil: "கணினி",
                                  kannada: "ಕಂಪ್ಯೂಟರ್"
                                },
                                "Smartphone": {
                                  telugu: "స్మార్ట్‌ఫోన్",
                                  hindi: "स्मार्टफोन",
                                  tamil: "ஸ்மார்ட்போன்",
                                  kannada: "ಸ್ಮಾರ್ಟ್ಫೋನ್"
                                },
                                "Television": {
                                  telugu: "టెలివిజన్",
                                  hindi: "टेलीविजन",
                                  tamil: "தொலைக்காட்சி",
                                  kannada: "ದೂರದರ್ಶನ"
                                },
                                "Radio": {
                                  telugu: "రేడియో",
                                  hindi: "रेडियो",
                                  tamil: "ரேடியோ",
                                  kannada: "ರೇಡಿಯೊ"
                                },
                                "Camera": {
                                  telugu: "కెమెరా",
                                  hindi: "कैमरा",
                                  tamil: "கேமரா",
                                  kannada: "ಕ್ಯಾಮೆರಾ"
                                },
                              
                                // Additional words
                                "Window": {
                                  telugu: "కిటికీ",
                                  hindi: "खिड़की",
                                  tamil: "சாளரம்",
                                  kannada: "ಕಿಟಕಿ"
                                },
                                "Door": {
                                  telugu: "తలుపు",
                                  hindi: "दरवाज़ा",
                                  tamil: "வாசல்",
                                  kannada: "ಬಾಗಿಲು"
                                },
                                "Curtain": {
                                  telugu: "పొర",
                                  hindi: "परदा",
                                  tamil: "திரை",
                                  kannada: "ಪರದೆ"
                                },
                                "Fan": {
                                  telugu: "ఫ్యాన్",
                                  hindi: "पंखा",
                                  tamil: "விசிறி",
                                  kannada: "ಫ್ಯಾನ್"
                                },
                                "Clock": {
                                  telugu: "గడియారం",
                                  hindi: "घड़ी",
                                  tamil: "கடிகாரம்",
                                  kannada: "ಗಡಿಯಾರ"
                                },
                              
                                // Additional words
                                "Refrigerator": {
                                  telugu: "రెఫ్రిజిరేటర్",
                                  hindi: "रेफ्रिजरेटर",
                                  tamil: "மிக்சி",
                                  kannada: "ಮಿಕ್ಸಿ"
                                },
                                "Washing Machine": {
                                  telugu: "వాషింగ్ మెషిన్",
                                  hindi: "वाशिंग मशीन",
                                  tamil: "உலர்த்தல் இயந்திரம்",
                                  kannada: "ಬಟ್ಟೆ ಒಗೆಯುವ ಯಂತ್ರ"
                                },
                                "Microwave": {
                                  telugu: "మైక్రోవేవ్",
                                  hindi: "माइक्रोवेव",
                                  tamil: "நுண்கதிரியக்க",
                                  kannada: "ಮೈಕ್ರೊವೇವ್"
                                },
                                "Oven": {
                                  telugu: "అవెన్",
                                  hindi: "ओवन",
                                  tamil: "ஒவென்",
                                  kannada: "ಒವನ"
                                },
                                "Mixer": {
                                  telugu: "మిక్సర్",
                                  hindi: "मिक्सर",
                                  tamil: "மிக்சி",
                                  kannada: "ಮಿಕ್ಸರ್"
                                },
                              
                                          

  };
  

const Words = () => {
  const [selectedWord, setSelectedWord] = useState('Apple');
  const [language, setLanguage] = useState('');

  const handleWordChange = (e) => {
    const newWord = e.target.value;
    setSelectedWord(newWord);
    // Read aloud the selected English word
    const utterance = new SpeechSynthesisUtterance(newWord);
    utterance.lang = 'en-US';
    speechSynthesis.speak(utterance);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    const word = wordsData[selectedWord][lang];
    const utterance = new SpeechSynthesisUtterance(word);
    utterance.lang = getLangCode(lang);
    speechSynthesis.speak(utterance);
  };

  const getLangCode = (lang) => {
    switch (lang) {
      case 'telugu':
        return 'te-IN';
      case 'hindi':
        return 'hi-IN';
      case 'tamil':
        return 'ta-IN';
      case 'kannada':
        return 'kn-IN';
      default:
        return 'en-US';
    }
  };

  return (
    <div className="words">
      <h1>Simple English Words for Kids</h1>
      <div>
        <label>
          Select Word:
          <select value={selectedWord} onChange={handleWordChange}>
            {Object.keys(wordsData).map((word) => (
              <option key={word} value={word}>{word}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="translations">
        <div>
          <h2>Telugu: {wordsData[selectedWord].telugu}</h2>
          <button onClick={() => handleLanguageChange('telugu')}>Read Aloud</button>
        </div>
        <div>
          <h2>Hindi: {wordsData[selectedWord].hindi}</h2>
          <button onClick={() => handleLanguageChange('hindi')}>Read Aloud</button>
        </div>
        <div>
          <h2>Tamil: {wordsData[selectedWord].tamil}</h2>
          <button onClick={() => handleLanguageChange('tamil')}>Read Aloud</button>
        </div>
        <div>
          <h2>Kannada: {wordsData[selectedWord].kannada}</h2>
          <button onClick={() => handleLanguageChange('kannada')}>Read Aloud</button>
        </div>
      </div>
    </div>
  );
};

export default Words;
